// Dropdown click event
document.querySelectorAll('.product-info__dropdown-heading--tab')?.forEach((element, index) => {
  // Find the div for the content
  const dropdownContent = element.parentElement.querySelector('.product-info__dropdown-content');
  const dropdownContentContainer = element.parentElement.querySelector('.product-info__dropdown-content-container');
  element.addEventListener('click', function () {
    handleDropdown(element, dropdownContent, dropdownContentContainer);
  });
});
document.querySelectorAll('.product-info__dropdown-heading--review')?.forEach((element, index) => {
  // Find the div for the content
  const dropdownContent = element.parentElement.querySelector('.product-info__dropdown-content');
  const dropdownContentContainer = element.parentElement.querySelector('.product-info__dropdown-content-container');
  const dropdownReview = document.querySelector('.product-info__review');
  const dropdownBtnReview = document.querySelector('.product-info__view-all');
  element.addEventListener('click', function () {
    handleDropdown(element, dropdownContent, dropdownContentContainer);
    dropdownReview.classList.toggle('product-info__review--is-visible');
    dropdownBtnReview.classList.toggle('product-info__view-all--is-visible');
  });
});
document.querySelector('.product-info__view-all')?.addEventListener('click', e => {
  const dropdownContent = e.target.parentElement.querySelector('.product-info__dropdown-content');
  const dropdownContentContainer = e.target.parentElement.querySelector('.product-info__dropdown-content-container');
  const dropdownReview = document.querySelector('.product-info__review');
  const dropdownBtnReview = document.querySelector('.product-info__view-all');
  handleDropdown(document.querySelector('.product-info__dropdown-heading--review'), dropdownContent, dropdownContentContainer);
  dropdownReview.classList.toggle('product-info__review--is-visible');
  dropdownBtnReview.classList.toggle('product-info__view-all--is-visible');
});
function handleDropdown(element, dropdownContent, dropdownContentContainer) {
  // Initialize the height of the parent, 0 when it's closed
  let initial_height = 0;

  // Check if the dropdown is open
  if (dropdownContent.classList.contains('product-info__dropdown-content--visible')) {
    // Remove the classes and set the initial height
    dropdownContentContainer.style.height = initial_height + "px";
    element.classList.toggle('product-info__dropdown-heading--active');
    element.parentElement.querySelector('.product-info__dropdown-content').classList.toggle('product-info__dropdown-content--visible');
  } else {
    // // If the element doesn't contain 'active', close all other elements; we skip this loop if we click on the same dropdown to perform a simple toggle
    // let active = document.querySelector('.product-info__dropdown-heading.product-info__dropdown-heading--active');
    // if (active != null){
    //     active.classList.remove('product-info__dropdown-heading--active')
    //     active.parentElement.querySelector('.product-info__dropdown-content').classList.remove('product-info__dropdown-content--visible')
    //     active.parentElement.querySelector('.product-info__dropdown-content-container').style.height = initial_height + "px";  
    // }

    // Add the classes and set the final height
    let final_height = 0 + dropdownContent.clientHeight;
    dropdownContentContainer.style.height = final_height + "px";
    element.classList.toggle('product-info__dropdown-heading--active');
    element.parentElement.querySelector('.product-info__dropdown-content').classList.toggle('product-info__dropdown-content--visible');
  }
  if (element.classList.contains('product-info__dropdown-heading--review')) {
    const container = element.closest('.product-info__dropdown-container');
    container.querySelector('.kl_reviews__load_more_button .kl_reviews__button').addEventListener('click', e => {
      waitForReviewOverlay(container);
    });
  }
}
function waitForReviewOverlay(container) {
  const loadingElement = container.querySelector('.kl_reviews__list_container > div:first-of-type');
  if (!loadingElement) {
    container.querySelector('.product-info__dropdown-content-container').style.height = container.querySelector('.product-info__dropdown-content--visible').clientHeight + 'px';
    return;
  }
  const updateHeight = () => {
    container.querySelector('.product-info__dropdown-content-container').style.height = container.querySelector('.product-info__dropdown-content--visible').clientHeight + 'px';
  };
  if (!loadingElement.classList.contains('kl_reviews__list_loading__overlay')) {
    updateHeight();
    return;
  }

  // Try MutationObserver first
  let observer = null;
  let timeoutId = null;
  const cleanup = () => {
    if (observer) {
      observer.disconnect();
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };
  observer = new MutationObserver(mutations => {
    const currentElement = container.querySelector('.kl_reviews__list_container > div:first-of-type');
    if (currentElement && !currentElement.classList.contains('kl_reviews__list_loading__overlay')) {
      updateHeight();
      cleanup();
    }
  });
  observer.observe(loadingElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  // Also observe parent in case element is replaced
  const listContainer = container.querySelector('.kl_reviews__list_container');
  if (listContainer) {
    observer.observe(listContainer, {
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  // Fallback: if observer doesn't catch it within 2 seconds, use requestAnimationFrame polling
  timeoutId = setTimeout(() => {
    cleanup();
    // Fall back to requestAnimationFrame polling
    const checkLoadingElement = () => {
      const currentElement = container.querySelector('.kl_reviews__list_container > div:first-of-type');
      if (!currentElement || !currentElement.classList.contains('kl_reviews__list_loading__overlay')) {
        updateHeight();
      } else {
        requestAnimationFrame(checkLoadingElement);
      }
    };
    checkLoadingElement();
  }, 2000);
}

// When the page is loaded, calculate the open dropdown if there is one to enable the closing transition
window.addEventListener("load", function () {
  const dropdownOpen = document.querySelector('.product-info__dropdown-content--visible');
  if (dropdownOpen != null) {
    dropdownOpen.closest(".product-info__dropdown-content-container").style.height = dropdownOpen.clientHeight + 'px';
  }
});

// Audio 

const audioPlayer = document.querySelector(".audio-player");
const url = "https:" + document.querySelector('.product-info__audio')?.getAttribute('data-audio');
const audio = new Audio(url);
if (url && audioPlayer) {
  audio.addEventListener("loadeddata", () => {
    audio.volume = .75;
  }, false);

  //click on timeline to skip around
  const timeline = audioPlayer?.querySelector(".timeline");
  timeline.addEventListener("click", e => {
    const timelineWidth = window.getComputedStyle(timeline).width;
    const timeToSeek = e.offsetX / parseInt(timelineWidth) * audio.duration;
    audio.currentTime = timeToSeek;
  }, false);

  //check audio percentage and update time accordingly
  setInterval(() => {
    const progressBar = audioPlayer.querySelector(".progress");
    progressBar.style.width = audio.currentTime / audio.duration * 100 + "%";
  }, 500);

  //toggle between playing and pausing on button click
  const playBtn = audioPlayer.querySelector(".controls .toggle-play");
  playBtn.addEventListener("click", () => {
    if (audio.paused) {
      playBtn.classList.remove("play");
      playBtn.classList.add("pause");
      audio.play();
    } else {
      playBtn.classList.remove("pause");
      playBtn.classList.add("play");
      audio.pause();
    }
  }, false);

  //turn 128 seconds into 2:08
  function getTimeCodeFromNum(num) {
    let seconds = parseInt(num);
    let minutes = parseInt(seconds / 60);
    seconds -= minutes * 60;
    const hours = parseInt(minutes / 60);
    minutes -= hours * 60;
    if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
    return `${String(hours).padStart(2, 0)}:${minutes}:${String(seconds % 60).padStart(2, 0)}`;
  }
  const rewindBtn = audioPlayer.querySelector(".rewind-10");
  rewindBtn.addEventListener("click", () => {
    audio.currentTime = Math.max(0, audio.currentTime - 10);
  }, false);

  // Bouton pour avancer de 10 secondes
  const forwardBtn = audioPlayer.querySelector(".forward-10");
  forwardBtn.addEventListener("click", () => {
    audio.currentTime = Math.min(audio.duration, audio.currentTime + 10);
  }, false);
  audio.addEventListener("ended", () => {
    audio.currentTime = 0;
    playBtn.classList.remove("pause");
    playBtn.classList.add("play");
  }, false);
}

// Ratings

function waitForElement(selector, callback) {
  const element = document.querySelector(selector);
  if (element) {
    callback(element);
  } else {
    const observer = new MutationObserver((mutations, me) => {
      const element = document.querySelector(selector);
      if (element) {
        callback(element);
        me.disconnect(); // Arrête d'observer une fois l'élément trouvé
      }
    });
    observer.observe(document, {
      childList: true,
      subtree: true
    });
  }
}
waitForElement('.yotpo-bottom-line-score', element => {
  document.querySelector('.product-info__title-container .yotpo-sr-bottom-line-text').textContent = element.textContent;
});
function showStickyAtc() {
  const stickyAtc = document.querySelector('.sticky-atc');
  const fixedAtc = document.querySelector('.fixed-atc');
  const footerElements = [document.getElementById('shopify-section-pre-footer'), document.getElementById('shopify-section-footer')].filter(Boolean);
  if (!stickyAtc || !fixedAtc) return;
  function checkPosition() {
    const offset = 115;
    const isFixedAtcOutOfView = fixedAtc.getBoundingClientRect().bottom <= offset;
    const isAnyFooterVisible = footerElements.some(element => element.getBoundingClientRect().top <= window.innerHeight);
    stickyAtc.classList.toggle('is-visible', isFixedAtcOutOfView && !isAnyFooterVisible);
  }
  window.addEventListener('scroll', checkPosition, {
    passive: true
  });
  checkPosition();
}
document.addEventListener('DOMContentLoaded', showStickyAtc);